import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import SideBarNew from "../../SideBarNew";
import TopBarNew from "../../TopBarNew";
import MenuIcon from "../../icons/MenuIcon.svg";
import TowerIcon2 from "../../icons/TowerIcon2.svg";
import AppConstants from "../../AppConstants";
import { activesubscription } from "../../redux";
import { getActiveTeam } from "../../Teams";
import {
  checkSubscriptionAndStorage,
  addUserAnalytic,
  updateOutTime,
} from "../../ReusableComponents/reusableFunctions";
import Search from "../../Icon/Search.png";
import TableView from "../../ReusableComponents/TableView/TableView.js";
import Viewbuttons from "../../ReusableComponents/ViewButtons/index.js";
import ButtonWithIcon from "../../ReusableComponents/ButtonWithIcon.js";
import { TowerCard } from "../../ReusableComponents/Tower Card/TowerCard.js";
import LoaderComponent from "../../ReusableComponents/LoaderComponent.js";
import whitePlus from "../../assets/Icons/whiteplus.png";
import CreateTowerPlan from "./CreateTowerPlan.js";
import * as API from "../../api.js";
import { useHistory } from "react-router-dom";

const TowerTowers = (props) => {
  const [user, setUser] = useState({ username: "Guest" });
  const [type, setType] = useState("viewer");
  const [sidebarMode, setSidebarMode] = useState("shrunk");
  const [showBackIcon, setShowBackIcon] = useState(true);
  const [globalState, setGlobalState] = useState({ selectView: "list" });
  const [tableState, setTableState] = useState({
    pageSize: 10,
    pageNumber: 1,
    orderBy: undefined,
    orderType: undefined,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [projects, setProjects] = useState([]);
  const [counts, setCounts] = useState(0);
  const location = useLocation();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const history = useHistory();
  const { rowData } = location?.state || {};
  const [plans, setAllPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [statusCounts, setStatusCounts] = useState({
    total: 0,
    pending: 0,
    in_progress: 0,
    completed: 0,
  });
  const [searchText, setSearchText] = useState("");

  const columns = [
    { Header: "Name", accessor: "plan_name", isSortable: true },
    { Header: "Created", accessor: "date_and_time", isSortable: true },
    { Header: "Description", accessor: "description" },
    {
      Header: "Capacity",
      accessor: "capacity",
      Cell: ({ row }) => {
        const { capacity, unit } = row.original;
        return capacity != null ? `${capacity} ${unit || ""}` : "—";
      },
    },
    { Header: "Location", accessor: "location" },
    { Header: "No. of Images", accessor: "images" },
    { Header: "No. of Defects", accessor: "defects" },
    {
      Header: "Installation Status",
      accessor: "installation_status",
      isSortable: true,
    },
  ];

  const handleStateChange = (key, value) => {
    setGlobalState((prev) => ({ ...prev, [key]: value }));
  };

  const sidebarConfigurations = {
    options: showBackIcon
      ? [
          { icon: MenuIcon, text: "Home", path: "/picstork/dashboard" },
          { icon: TowerIcon2, text: "Projects", path: "/picstork/towers" },
        ]
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
  };

  const topbarConfigurations = {
    options: showBackIcon
      ? [
          {
            icon: MenuIcon,
            text: "Dashboard",
            path: "/picstork/dashboard",
          },
          {
            icon: MenuIcon,
            text: "Total Projects",
            path: "/picstork/total-projects",
          },
          {
            icon: MenuIcon,
            text: `${rowData?.project_name}`,
            path: "/picstork/total-towers",
            rowData: rowData,
          },
        ]
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
  };

  function useDebounce(value, delay = 500) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => setDebounced(value), delay);
      return () => clearTimeout(handler);
    }, [value, delay]);
    return debounced;
  }

  const debouncedKey = useDebounce(searchText, 500);

  const getAllPlans = (status = "all") => {
    setSelectedStatus(status);
    setIsLoading(true);
    let projectName = rowData?.project_name;
    const id = rowData?.id;

    API.getPlans(
      projectName,
      searchText || " ",
      10000,
      0,
      3,
      id,
      "",
      "",
      tableState.orderBy,
      tableState.orderType,
      status
    ).then(
      (data) => {
        const formattedPlans = (data.plans || []).map((plan) => {
          const planStatus = plan.installation_status
            ? plan.installation_status.replace(/_/g, " ")
            : "—";

          let statusColor = "#000";
          if (planStatus === "Pending") statusColor = "#D9C514";
          else if (planStatus === "In Progress") statusColor = "#4E4AFF";
          else if (planStatus === "Completed") statusColor = "#01B574";

          return {
            ...plan,
            date_and_time: plan.date_and_time
              ? new Date(plan.date_and_time).toISOString().split("T")[0]
              : "—",
            installation_status: (
              <span style={{ color: statusColor, fontWeight: 600 }}>
                {planStatus}
              </span>
            ),
          };
        });

        setAllPlans(formattedPlans);
        setCounts(formattedPlans.length);
        setIsLoading(false);
      },
      (e) => {
        console.log(e);
        setIsLoading(false);
      }
    );
  };

  useEffect(() => {
    if (rowData?.project_name && rowData?.id) {
      getAllPlans();
    }
  }, [rowData, isCreateModalOpen, debouncedKey, tableState]);

  useEffect(() => {
    if (!rowData?.id) return;

    const fetchStatusCounts = async () => {
      try {
        const data = await API.getPlanStatusCount(rowData?.id);
        setStatusCounts(data);
      } catch (err) {
        console.error("Error fetching plan status counts:", err);
      }
    };

    fetchStatusCounts();
  }, [rowData?.id]);

  return (
    <div className="wrapper">
      <SideBarNew
        config={sidebarConfigurations}
        showMainDashboardIcons={showBackIcon}
        parentSidebarSwitch={() =>
          setSidebarMode(sidebarMode === "shrunk" ? "expanded" : "shrunk")
        }
      />

      <div
        className="right-content"
        style={{ backgroundColor: "#EAEDF0" }}
        onClick={() => setSidebarMode("shrunk")}
      >
        <TopBarNew config={topbarConfigurations} />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "20px",
            padding: "20px",
          }}
        >
          {/* Status Summary Cards */}
          <div
            style={{
              display: "flex",
              gap: "45px",
              marginBottom: "20px",
              flexWrap: "wrap",
            }}
          >
            {/* Total Towers */}
            <div
              style={{
                backgroundColor: "#fff",
                padding: "15px 20px",
                borderRadius: "10px",
                flex: "1 1 200px",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "15px",
                position: "relative",
                cursor: "pointer",
              }}
              onClick={() => getAllPlans("all")}
            >
              {/* Blue half-slider chip */}
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  top: "20%",
                  bottom: "20%",
                  width: "4px",
                  borderRadius: "3px",
                  backgroundColor: "#41009B",
                }}
              />

              <div style={{ fontSize: "14px", color: "#6B6B6B" }}>
                Total Towers
              </div>
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "rgba(31, 28, 69, 1)",
                }}
              >
                {statusCounts.total}
              </div>
            </div>

            {/* Inspection Completed */}
            <div
              style={{
                backgroundColor: "#fff",
                padding: "15px 20px",
                borderRadius: "10px",
                flex: "1 1 200px",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "15px",
                position: "relative",
                cursor: "pointer",
              }}
              onClick={() => getAllPlans("Completed")}
            >
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  top: "20%",
                  bottom: "20%",
                  width: "4px",
                  borderRadius: "3px",
                  backgroundColor: "#01B574",
                }}
              />
              <div style={{ fontSize: "14px", color: "#6B6B6B" }}>
                Inspection Completed
              </div>
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "rgba(31, 28, 69, 1)",
                }}
              >
                {statusCounts.completed}
              </div>
            </div>

            {/* Inspection In Progress */}
            <div
              style={{
                backgroundColor: "#fff",
                padding: "15px 20px",
                borderRadius: "10px",
                flex: "1 1 200px",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "15px",
                position: "relative",
                cursor: "pointer",
              }}
              onClick={() => getAllPlans("In_Progress")}
            >
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  top: "20%",
                  bottom: "20%",
                  width: "4px",
                  borderRadius: "3px",
                  backgroundColor: "#4E4AFF",
                }}
              />
              <div style={{ fontSize: "14px", color: "#6B6B6B" }}>
                Inspection In Progress
              </div>
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "rgba(31, 28, 69, 1)",
                }}
              >
                {statusCounts.in_progress}
              </div>
            </div>

            {/* Inspection Pending */}
            <div
              style={{
                backgroundColor: "#fff",
                padding: "15px 20px",
                borderRadius: "10px",
                flex: "1 1 200px",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "15px",
                position: "relative",
                cursor: "pointer",
              }}
              onClick={() => getAllPlans("Pending")}
            >
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  top: "20%",
                  bottom: "20%",
                  width: "4px",
                  borderRadius: "3px",
                  backgroundColor: "#D9C514",
                }}
              />
              <div style={{ fontSize: "14px", color: "#6B6B6B" }}>
                Inspection Pending
              </div>
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "rgba(31, 28, 69, 1)",
                }}
              >
                {statusCounts.pending}
              </div>
            </div>
          </div>

          <div
            className="slide"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <div
              className="services-content-title"
              style={{
                display: "flex",
                alignItems: "center",
                color: "#1F1C45",
                fontWeight: 600,
              }}
            >
              {selectedStatus === "all"
                ? `Total Towers (${counts})`
                : `${selectedStatus.replace(/_/g, " ")} (${counts})`}
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                paddingRight: "8px",
              }}
            >
              <div>
                <img
                  src={Search}
                  style={{
                    height: "20px",
                    width: "20px",
                    position: "relative",
                    left: "25px",
                  }}
                />
                <input
                  type="text"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  className="add-user-form-text2"
                  placeholder="Search"
                  style={{
                    height: "30px",
                    width: "230px",
                    paddingLeft: "28px",
                    border: "1px solid rgba(102, 102, 102, 0.3)",
                  }}
                />
              </div>
            </div>
          </div>

          {isLoading ? (
            <LoaderComponent />
          ) : (
            <TableView
              columns={columns}
              data={plans}
              count={counts}
              showSrNo={true}
              onStateChange={setTableState}
              pageNumber={tableState.pageNumber}
              onClickRow={(row) => {
                history.push(`/picstork/progress-details`, {
                  rowData: row?.progress_checklist,
                  status: row?.installation_status?.props,
                  projectName: rowData?.project_name,
                  id: rowData?.id,
                  planName: row?.plan_name,
                });
              }}
            />
          )}
        </div>
      </div>
      <CreateTowerPlan
        isOpen={isCreateModalOpen}
        onRequestClose={() => {
          setIsCreateModalOpen(false);
          setSelectedPlan({});
        }}
        onSubmit={(newTower) => {
          setSelectedPlan({});
        }}
        projectData={rowData}
        editData={selectedPlan}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  activesubscription: (payload) => dispatch(activesubscription(payload)),
});

const mapStateToProps = (state) => ({
  SubscriptionData: state.subscription.subscriptionData,
});

export default connect(mapStateToProps, mapDispatchToProps)(TowerTowers);
